import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('help_hubs_hide_nav_menus');
	},
};
